import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Box, Button, Typography } from '@mui/material';
import DonationRequestCard from './DonationRequestCard';

const DonationRequestsCards = ({ isLoading, donations, onEditClick }) => {
  if (!isLoading && donations.length === 0) {
    return (
      <Box sx={{ height: '100%', width: '100%', overflow: 'auto', backgroundColor: 'background.default' }}>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            WebkitTransform: 'translate(-50%, -50%)',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography color="textSecondary" variant="h5">
            You have no requests to donate.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <div>
      <Virtuoso
        totalCount={donations.length}
        style={{ height: 'calc(100vh - 70px)' }}
        itemContent={index => {
          const donationRequest = donations[index];
          const top = index === 0 ? 0 : 1;
          const bottom = index === donations ? 0 : 1;
          return (
            <Box pt={top} pb={bottom} px={1} key={donationRequest.id}>
              <DonationRequestCard donationRequest={donationRequest} isLoading={isLoading}>
                <Button
                  fullWidth
                  size="large"
                  color="primary"
                  variant="contained"
                  disabled={donationRequest.status !== 'pending'}
                  onClick={() => onEditClick(donationRequest.id)}
                >
                  Edit
                </Button>
              </DonationRequestCard>
            </Box>
          );
        }}
      />
    </div>
  );
};

export default DonationRequestsCards;
